<template>
    <ul>
        <li :id="item.id" v-for="item in items" :data-jstree="defineType(item.type)">
            {{getName(item)}}
            <role-tree-acl :field="field" v-if="item[field] && item[field].length > 0" :items="item[field]"></role-tree-acl>
        </li>
    </ul>
</template>

<script>
   
    export default { 
        name: 'role-tree-acl',
        props: ['items','field'],
        methods: {
            getName: function(item)
            {
                let name = item.name;
                if(this.$root.$env.DEBUG && item.code)
                {
                    name += ' - ' + item.code;
                }
                return name;
            },
            defineType: function(type){
                switch(type)
                {
                    case 'module':      
                        return '{"icon":"fas fa-cog","opened":"false"}';
                        break;
                    case 'divider':     
                        return '{"icon":"fas fa-puzzle-piece","opened":false}';
                        break;
                    case 'resource':    
                        return '{"icon":"fas fa-chevron-right","opened":false}';
                        break;
                }
            }
        }
    }       
</script>